import { environment } from '.';
import { Environment } from './types';

type AwsConfig = {
  aws_project_region: string;
  aws_cognito_identity_pool_id: string;
  aws_cognito_region: string;
  aws_user_pools_id: string;
  aws_user_pools_web_client_id: string;
  aws_appsync_graphqlEndpoint: string;
  aws_appsync_region: string;
  aws_mobile_analytics_app_id: string;
  aws_mobile_analytics_app_region: string;
  Analytics: {
    /** MARK: otherwise it raises an error during local development */
    disabled: boolean;
  };
};

type ConfigEnv = {
  [key in Environment]: AwsConfig;
};

const dev: AwsConfig = {
  aws_project_region: 'us-west-2',
  aws_cognito_identity_pool_id: 'us-west-2:c05656cc-fd86-4c89-abe9-2089d2dd6f1e',
  aws_cognito_region: 'us-west-2',
  aws_user_pools_id: 'us-west-2_V8I6DuORj',
  aws_user_pools_web_client_id: '1oknn840mu1mopec387e113nr',
  aws_appsync_graphqlEndpoint:
    'https://lm5sn3bx2rettnhfy7bd5yuwvy.appsync-api.us-west-2.amazonaws.com/graphql',
  aws_appsync_region: 'us-west-2',
  aws_mobile_analytics_app_id: '780140a7bd624083914ae1129de1422b',
  aws_mobile_analytics_app_region: 'us-west-2',
  Analytics: {
    disabled: false,
  },
};

const config: ConfigEnv = {
  local: dev,
  dev,
  production: {
    aws_project_region: 'us-west-2',
    aws_cognito_identity_pool_id: 'us-west-2:fb6c4db0-eb35-4d3a-9acf-6432a1983f3c',
    aws_cognito_region: 'us-west-2',
    aws_user_pools_id: 'us-west-2_YmwGAd3ju',
    aws_user_pools_web_client_id: '6nnvkf9o6f3bcm54t411l4cl4u',
    aws_appsync_graphqlEndpoint:
      'https://3w5s6bzgwbgr3jf43uggcmxw3y.appsync-api.us-west-2.amazonaws.com/graphql',
    aws_appsync_region: 'us-west-2',
    aws_mobile_analytics_app_id: '994978da01ba49ccb7b1e278c57eac84',
    aws_mobile_analytics_app_region: 'us-west-2',
    Analytics: {
      disabled: false,
    },
  },
};

export default config[environment];
